<template>
	<a-tabs default-active-key="1" @change="callback">
		<a-tab-pane key="1" tab="行业列表">
			<div class="content_main" id="content_main">
				<div style="margin-top: 10px">
					<a-button type="primary" @click="modification" style="margin-right: 5px">
						新增行业
					</a-button>
				</div>
				<div class="content_main_top">
					<a-input v-model="query.industryCode" allowClear class="a_input_self margin_self" placeholder="行业编号"
						@keyup.enter.native="queryserch" />
					<a-input v-model="query.industryName" allowClear class="a_input_self margin_self" placeholder="行业名称"
						@keyup.enter.native="queryserch" />
					<a-button type="primary" @click="queryserch" style="margin-left: 10px"> 查询 </a-button>
					<a-button type="primary" ghost @click="queryall"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll" ref="centerTable">
					<a-table :columns="columnslist" :data-source="datalist" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination" @change="changeTable">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
						</span>
						<span slot="action" slot-scope="text, record">
							<a @click="details(record)">详情</a>
							<a-divider type="vertical" />
							<a @click="edit(record)">编辑</a>
							<a-divider type="vertical" />
               <a @click="confirm(record)">删除</a>
						</span>
					</a-table>
				</div>
				<!-- 新增行业 -->
				<a-modal title="新增行业" :visible="addvisible" @ok="addOk"  @cancel="resetAddIndustry">
					<a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="labelCol"
						:wrapper-col="wrapperCol">
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="所属项目">
									<span>{{programName}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="行业编号" prop="industryCode" :rules="{
							  required: true,
							  message: '请输入行业编号',
							  trigger: 'change',
							}">
									<a-input v-model="form.industryCode" allowClear placeholder="行业编号"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="行业名称" prop="industryName" :rules="{
							  required: true,
							  message: '请输入行业名称',
							  trigger: 'change',
							}">
									<a-input v-model="form.industryName" allowClear placeholder="行业名称"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
			<!-- <template slot="footer">
				<a-button key="back" @click="cancleForm"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="addcustomerService"> 确定 </a-button>
			</template> -->
				</a-modal>
				<a-modal :title="types==1?'行业列表-编辑行业':'行业列表-详情'" :visible="allvisible" @cancel="closeVisible"
					width="50%">
					<template slot="footer" v-if="types==1">
						<a-button key="back" @click="closeVisible"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="getOkAll"> 保存 </a-button>
					</template>
					<template slot="footer" v-else>
						<a-button key="back" @click="allvisible = false"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="allvisible = false"> 确定 </a-button>
					</template>
					<a-form-model :model="allform" :rules="rules" ref="allForm" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
						<a-row>
							<a-col :span="12">
							    <a-form-model-item label="所属项目">
									<span>{{programName}}</span>
							    </a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="行业编号" v-if="types==1" prop="industryCode" :rules="{
							  required: true,
							  message: '请输入行业编号',
							  trigger: 'change',
							}">
									<a-input v-model="allform.industryCode" placeholder="行业编号" disabled/>
								</a-form-model-item>
								<a-form-model-item label="行业编号" v-else>
									<span>{{allform.industryCode}}</span>
								</a-form-model-item>
							</a-col>
							<!-- <a-col :span="12"> -->
								<a-col :span="12">
								<a-form-model-item label="行业名称" prop="industryName" v-if="types==1" :rules="{
							  required: true,
							  message: '请输入行业编号',
							  trigger: 'change',
							}">
								<a-input v-model="allform.industryName" placeholder="行业编号" />
									<!-- <a-select allowClear placeholder="行业名称" v-model="allform.industryName"
										@change="changeName"> -->
									
										<!-- <a-select-option :value="item.id" v-for="(item, index) in datalist"
											:key="index">
											{{ item.industryName }}
										</a-select-option> -->
									<!-- </a-select> -->
								</a-form-model-item>
									<a-form-model-item label="行业名称" v-else>
									<span>{{allform.industryName}}</span>
								</a-form-model-item>
								
							</a-col>
								<!-- <a-form-model-item label="行业名称" v-if="types==1" prop="industryName" :rules="{
								  required: true,
								  message: '请输入行业名称',
								  trigger: 'change',
								}">
									<a-input v-model="allform.industryName" placeholder="行业名称" />
								</a-form-model-item> -->




								<!-- <a-form-model-item label="行业名称" v-else>
									<span>{{allform.industryName}}</span>
								</a-form-model-item>
							</a-col> -->
						</a-row>
						<!-- <a-row>
							<a-col :span="12">
								<a-form-model-item label="所属项目" v-if="types==1" prop="ownProject" :rules="{
								  required: true,
								  message: '请输入所属项目',
								  trigger: 'change',
								}">
									<a-input v-model="allform.ownProject" placeholder="所属项目" />
								</a-form-model-item>
								
							</a-col>
						<a-row> -->
						<a-row>
							<a-col :span="12">
								<!-- <a-form-model-item label="创建时间" v-if="types==1" prop="createTime" :rules="{
								  required: true,
								  message: '请输入创建时间',
								  trigger: 'change',
								}">
									<a-input v-model="allform.createTime" placeholder="创建时间" />
								</a-form-model-item> -->

								<a-form-model-item label="创建时间"  v-if="types==0">
									<span>{{allform.createTime}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<!-- <a-form-model-item label="更新时间" v-if="types==1" prop="updateTime" :rules="{
								  required: true,
								  message: '请输入更新时间',
								  trigger: 'change',
								}">
									<a-input v-model="allform.updateTime" placeholder="更新时间" />
								</a-form-model-item> -->
								<a-form-model-item label="更新时间"  v-if="types==0">
									<span>{{allform.updateTime}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
				</a-modal>
			</div>
		</a-tab-pane>
		<a-tab-pane key="2" tab="岗位列表">
			<div class="content_main" id="content_main">
				<div style="margin-top: 10px">
					<a-button type="primary" @click="PostWith" style="margin-right: 5px">
						新增岗位
					</a-button>
				</div>
				<div class="content_main_top">
					<a-input v-model="query2.industryName" allowClear class="a_input_self margin_self"
						placeholder="行业名称" @keyup.enter.native="queryserch2" />
					<a-input v-model="query2.postName" allowClear class="a_input_self margin_self" placeholder="岗位名称"
						@keyup.enter.native="queryserch2" />
					<a-button type="primary" @click="queryserch2" style="margin-left: 10px"> 查询 </a-button>
					<a-button type="primary" ghost @click="queryall2"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll" ref="centerTable">
					<a-table :columns="columnslist2" :data-source="dataclaim" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination2" @change="changeTableclaim">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination2.current - 1) * pagination2.pageSize + index + 1 }}
						</span>
						<span slot="action" slot-scope="text, record">
							<a @click="postdetails(record)">详情</a>
							<a-divider type="vertical" />
							<a @click="postedit(record)">编辑</a>
						</span>
					</a-table>
				</div>
				<a-modal title="新增岗位" :visible="addpostvisible" @ok="addpostOk" @cancel="closeAddPost"
					width="40%">
					<a-form-model :model="formHazard" :rules="rules" ref="ruleForm2" :label-col="labelCol"
						:wrapper-col="wrapperCol">
						<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="所属行业" v-model="formHazard.quotePostInfo.industryName" prop="quotePostInfo.industryName" :rules="{
							  required: true,
							  message: '请选择所属行业',
							  trigger: 'change',
							}">
									<a-select allowClear placeholder="所属行业"
										@change="changeName">
										<a-select-option :value="item.id" v-for="(item, index) in datalist"
											:key="index">
											{{ item.industryName }}
										</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="岗位名称" prop="quotePostInfo.postName" :rules="{
							  required: true,
							  message: '请输入岗位名称',
							  trigger: 'change',
							}">
									<a-input v-model="formHazard.quotePostInfo.postName" allowClear placeholder="岗位名称">
									</a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row v-for="(domain, index) in formHazard.quoteHarmFactorList" :key="index">
							<a-row>
								<div class="pay_top">
									<span class="form_title">危害因素({{index+1}})</span>
									<span class="close_icon" @click="close_detail(index)" v-if="formHazard.quoteHarmFactorList.length > 1"> 删除 </span>
								</div>
							</a-row>
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="危害因素名称"
										:prop="factorName" :rules="{
                  required: true,
                  message: '请输入危害因素名称',
                  trigger: 'change',
                }">
									<a-select allowClear show-search placeholder="危害因素" v-model="domain.fullName"  :filter-option="filterOption"
										@change="changeHarmFactor($event, index)">
										<a-select-option :value="item.id" v-for="(item, index) in factorList"
											:key="index" :title="item.fullName">
											{{ item.fullName }}
										</a-select-option>
									</a-select>
										<!-- <a-input v-model="domain.factorName" placeholder="危害因素名称"></a-input> -->
									</a-form-model-item>
								</a-col>
							</a-row>
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="单价(元)">
										<a-input v-model="domain.price" type="number" placeholder="单价(元)" disabled></a-input>
									</a-form-model-item>
								</a-col>
							</a-row>
						</a-row>
						<a-row>
							<div class="rowBox">
								<a-button type="primary" @click="addPush"> 添加危害因素 </a-button>
							</div>
						</a-row>
					</a-form-model>
				</a-modal>
				<a-modal :title="posttypes==1?'岗位列表-编辑':'岗位列表-详情'" :visible="postvisible" @cancel="postvisible = false"
					width="50%">
					<template slot="footer" v-if="posttypes == 1">
						<a-button key="back" @click="postvisible = false"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="getOkPost"> 保存 </a-button>
					</template>
					<template slot="footer" v-else>
						<a-button key="back" @click="postvisible = false"> 取消 </a-button>
						<!-- <a-button key="submit" type="primary" @click="postvisible = false"> 确定 </a-button> -->
					</template>
				<!-- <div> -->
					<a-form-model :model="postform" :rules="rules" ref="postForm" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
						<div>
							<span class="sizeStyle" v-if="posttypes == 0">基本信息</span>
						</div>
						<div class="baseContainer"> 
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="行业名称" v-if="posttypes == 1" prop="quotePostInfo.industryName" :rules="{
								  required: true,
								  message: '请输入行业名称',
								  trigger: 'change',
								}">
									<a-select disabled="true" allowClear placeholder="行业名称" v-model="postform.quotePostInfo.industryName" @change="changeName">
								       <a-select-option :value="item.id" v-for="(item, index) in datalist"
											:key="index">
											{{ item.industryName }}
										</a-select-option>
							     </a-select>
									<!-- <span>{{postform.industryName}}</span> -->
								</a-form-model-item>
              </a-col>
              <a-col :span="12">
								<a-form-model-item label="行业名称" v-if="posttypes==0">
									<span>{{postform1.industryName}}</span>
								</a-form-model-item>
							</a-col>
              <a-col :span="12">
                <a-form-model-item label="岗位名称" v-if="posttypes==0">
									<span>{{postform1.postName}}</span>
								</a-form-model-item>
              </a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="岗位名称" v-if="posttypes==1" prop="quotePostInfo.postName" :rules="{
							  required: true,
							  message: '请输入岗位名称',
							  trigger: 'change',
							}">
									<a-input v-model="postform.quotePostInfo.postName" placeholder="岗位名称"  />
								</a-form-model-item>
							</a-col>
						</a-row>
            <div v-if= " posttypes==1 ">
						<a-row v-for="(item1, index) in postform.quoteHarmFactorList1" :key="index"  >
							<a-row>
								<div class="pay_top">
									<span class="form_title">新增危害因素({{index+1}})</span>
									<span class="close_icon" @click="close_detail1(index)"> 删除 </span>
								</div>
							</a-row>
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="危害因素名称" prop="factorName" >
										<a-select allowClear placeholder="危害因素" v-model="item1.fullName" :disabled="item1.disabled" show-search :filter-option="filterOption"
										@change="changeName1($event, index)" maxTagPlaceholder>
										<a-select-option :value="item.id" v-for="(item, index) in factorList"
											:key="index" :title="item.fullName">
                      {{item.fullName}}
											<!-- {{ item.factorName }} {{ item.standardInfo}} -->
                      <!-- <span class="tmp" id="tmp" > {{ item.factorName }} {{ item.standardInfo}}</span> -->

										</a-select-option>
										</a-select>
									</a-form-model-item>
								</a-col>
							</a-row>	
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="单价(元)">
										<a-input v-model="item1.price" type="number" placeholder="单价(元)" disabled></a-input>
									</a-form-model-item>
								</a-col>
							</a-row>	
							<a-row v-if= " posttypes==0 ">
								<a-col :span="24">
									<a-form-model-item label="单价(元)">
									</a-form-model-item>
								</a-col>
							</a-row>
						</a-row>
						<a-row>
							<div class="rowBox">
								<a-button type="primary" @click="addPush1"> 添加危害因素 </a-button>
							</div>
						</a-row>
        </div>
        <a-row>
							<a-col :span="12">
								<a-form-model-item label="创建时间" v-if="posttypes==0">
									<span>{{postform1.createTime}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="更新时间" v-if="posttypes==0">
									<span>{{postform1.updateTime}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="创建人"  v-if="posttypes==0">
									<span>{{postform1.creator}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						
						</div>
						<div>
							<span class="sizeStyle" v-if="posttypes == 0">危害因素</span>
						</div>
						<div class="baseContainer">
				<a-row> 
					<div v-if="posttypes==0">
						<a-table :columns="columns" :data-source="harmfulData" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination4" @change="changeTableclaim4">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination4.current - 1) * pagination4.pageSize + index + 1 }}
						</span>
					</a-table>
					</div>
				   </a-row> 
				</div>
					</a-form-model>
				</a-modal>
			</div>
		</a-tab-pane>
	
		<a-tab-pane key="3" tab="危害因素报价表">
			<div class="content_main" id="content_main">
				<div style="margin-top: 10px">
					<a-button type="primary" @click="factorsAdd" style="margin-right: 5px">
						新增危害因素
					</a-button>
				</div>
				<div class="content_main_top">
					<!-- <a-select allowClear placeholder="所属收费标准" v-model="query3.categoryId" class="a_input_self margin_self" @change="changeName3"
						@keyup.enter.native="queryserch3">
						<a-select-option :value="item.categoryId" v-for="(item, index) in factorsCateList" :key="index">
							{{ item.categoryName }}
						</a-select-option>
					</a-select> -->
					<a-select allowClear placeholder="所属子标准" v-model="query3.subcategoryId" class="a_input_self margin_self"
						@keyup.enter.native="queryserch3">
						<a-select-option :value="item.categoryId" v-for="(item, index) in subCategoryData" :key="index">
							{{ item.categoryName }}
						</a-select-option>
					</a-select>
					<a-input v-model="query3.factorName" allowClear class="a_input_self margin_self" placeholder="危害因素"
						@keyup.enter.native="queryserch3" />
					<a-button type="primary" @click="queryserch3" style="margin-left: 10px"> 查询 </a-button>
					<a-button type="primary" ghost @click="queryall3"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll"  ref="centerTable">
					<a-table :columns="columnslist3" :data-source="dataclaim2" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination3" @change="changeTableclaim2">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination3.current - 1) * pagination3.pageSize + index + 1 }}
						</span>
						<span slot="action" slot-scope="text, record">
							<a @click="edit3(record)">编辑</a>
							<a-divider type="vertical" />
							<a @click="details3(record)">详情</a>
							<a-divider type="vertical" />
              <a @click="delete3(record)">删除</a>
							<!-- <a-popconfirm
                                  title="是否确认删除?"
                                  ok-text="确认"
                                  cancel-text="取消"
                                  @confirm="delete3(record)"
                                  @cancel="cancel"
                               >
                                <a href="#">删除</a>
                            </a-popconfirm>    -->
							<!-- <a @click="delete3(record)">删除</a> -->
						
						</span>
					</a-table>
				</div>
				<a-modal title="新增危害因素报价" :visible="factorsvisible" @ok="factorsOk" @cancel="closeFactor"
					width="40%">
					<a-form-model :model="formfactors" :rules="rules" ref="ruleForm3" :label-col="labelCol"
						:wrapper-col="wrapperCol">
						<a-row>
							<a-col :span="24">
								<!-- <a-form-model-item label="所属收费标准" prop="categoryId"> -->

                          <a-form-model-item label="所属收费标准" prop="categoryId" :rules="{
							  required: true,
							  message: '请选择所属收费标准',
							  trigger: 'change',
							}">
									<a-select allowClear placeholder="所属收费标准" v-model="formfactors.categoryId"
										@change="changeName3" disabled>
										<a-select-option :value="item.categoryId" v-for="(item, index) in factorsCateList"
											:key="index">
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
						</a-form-model-item>
							</a-col >
						</a-row>
						<a-row>
							<a-col :span="24">
								 <a-form-model-item label="所属子标准" prop="subcategoryId" :rules="{
							  required: true,
							  message: '请选择所属子标准',
							  trigger: 'change',
							}">
									<a-select allowClear placeholder="所属子标准" v-model="formfactors.subcategoryId">
										<a-select-option :value="item.categoryId" v-for="(item, index) in subcategoryList"
											:key="index">
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
						</a-form-model-item>
							</a-col>
						
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="名称" prop="factorName" :rules="{
							  required: true,
							  message: '请输入名称',
							  trigger: 'change',
							}">
									<a-input v-model="formfactors.factorName" allowClear placeholder="名称"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="检测标准" prop="standardInfo" :rules="{
							  required: true,
							  message: '请输入检测标准',
							  trigger: 'change',
							}">
									<a-input v-model="formfactors.standardInfo" allowClear placeholder="检测标准"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="限制范围" prop="limitRange">
									<a-input v-model="formfactors.limitRange" allowClear placeholder="限制范围"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="单价(元)" prop="price"  :rules="{
							  required: true,
							  message: '请输入单价(元)，只能为小数或者整数',
							  trigger: 'change',
							}">
									<a-input v-model="formfactors.price" oninput="value=value.replace(/[^\d\.]/g,'')" allowClear placeholder="单价(元)"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
				</a-modal>
				<a-modal :title="factorsTypes==1?'危害因素列表-编辑':'危害因素列表-详情'" :visible="factorsDetailVisible" @cancel="factorsDetailVisible = false"
					width="50%">
					<template slot="footer" v-if="factorsTypes==1">
						<a-button key="back" @click="factorsDetailVisible = false"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="editFactorsDetail"> 保存 </a-button>
					</template>
					<template slot="footer" v-else>
						<a-button key="back" @click="factorsDetailVisible = false"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="factorsDetailVisible = false"> 确定 </a-button>
					</template>
					<a-form-model :model="hazardsList" :rules="rules" ref="hazardsList" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="所属收费标准" v-if="factorsTypes==1" prop="categoryId" :rules="{
							  required: true,
							  message: '请选择所属收费标准',
							  trigger: 'change',
							}">
							<!-- <a-input v-model="hazardsList.category" v-if="factorsTypes==0"></a-input> -->
									<a-select allowClear placeholder="所属收费标准"  v-model="hazardsList.categoryId" 
										@change="changeName3" disabled>
										<a-select-option :value="item.categoryId" v-for="(item, index) in factorsCateList"
											:key="index" >
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
							</a-form-model-item>
							<a-form-model-item label="所属收费标准"  v-else>
									<span>{{hazardsList.category}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="所属子标准" prop="subcategory" v-if="factorsTypes == 1" :rules="{
							  required: true,
							  message: '请选择所属子标准',
							  trigger: 'change',
							}">
									<a-select allowClear placeholder="所属子标准" v-model="hazardsList.subcategory" @change="changeName4">
										<a-select-option :value="item.categoryId" v-for="(item, index) in subcategoryList" :key="index">
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
							</a-form-model-item>
								<a-form-model-item label="所属子标准"  v-else>
									<span>{{hazardsList.subcategory}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="名称" v-if="factorsTypes == 1" prop="factorName" :rules="{
							  required: true,
							  message: '请输入名称',
							  trigger: 'change',
							}">
									<a-input v-model="hazardsList.factorName" placeholder="名称" />
								</a-form-model-item>
								<a-form-model-item label="名称" v-else>
									<span>{{hazardsList.factorName}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="检测标准" v-if="factorsTypes == 1" prop="standardInfo" :rules="{
								  required: true,
								  message: '请输入检测标准',
								  trigger: 'change',
								}">
									<a-input v-model="hazardsList.standardInfo" placeholder="检测标准"/>
								</a-form-model-item>
								<a-form-model-item label="检测标准"  v-else>
									<span>{{hazardsList.standardInfo}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="限制范围" v-if="factorsTypes == 1" prop="limitRange">
									<a-input v-model="hazardsList.limitRange" placeholder="请输入"/>
								</a-form-model-item>
								<a-form-model-item label="限制范围"  v-else>
									<span>{{hazardsList.limitRange}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="单价(元)" v-if="factorsTypes == 1" prop="price" :rules="{
								  required: true,
								  message: '请输入单价',
								  trigger: 'change',
								}">
									<a-input v-model="hazardsList.price" placeholder="请输入"/>
								</a-form-model-item>
								<a-form-model-item label="单价(元)"  v-else>
									<span>{{hazardsList.price}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
				</a-modal>
			</div>
		</a-tab-pane>
	</a-tabs>
</template>

<script>
import {
  delete_factor,
  getFactorDetail,
  getUserListDetail,
  industryInfo,
  industryInfo_post,
  postInfo,
  addPostWithHarmFactor,
  editPostWithHarmFactor,
  industryInfo_details,
  industryInfo_put,
  postInfo_details,
  postInfo_put,
  baseFactor,
  getCategoryTree,
  subCategory,
  baseFactor_add,
  factor_details,
  editFactors_put,
  factor_list,
  deleteIndustryInfo,
  deleteFactor,
  getUserList,
} from '@/api/Industry'
import addParameter from '../Quotation/parameter/addParameter.vue'
import { getCategoryList} from '@/api/surrounding'
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    // width: 120,
    ellipsis: true,
  },
  {
    title: '危害因素名称',
    dataIndex: 'fullName',
    key: 'fullName',
  },
  {
    title: '单价(元)',
    dataIndex: 'price',
    key: 'price',
    // width: 80,
  },
]
const columnslist = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '行业编号',
    dataIndex: 'industryCode',
    key: 'industryCode',
    ellipsis: true,
  },
  {
    title: '行业名称',
    dataIndex: 'industryName',
    key: 'industryName',
    ellipsis: true,
  },
  {
    title: '所属项目',
    dataIndex: 'ownProject',
    key: 'ownProject',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    fixed: 'right',
    width: 180,
  },
]
const columnslist2 = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '行业名称',
    dataIndex: 'industryName',
    key: 'industryName',
    ellipsis: true,
  },
  {
    title: '岗位名称',
    dataIndex: 'postName',
    key: 'postName',
    ellipsis: true,
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    fixed: 'right',
    width: 150,
  },
]
const columnslist3 = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '所属收费标准',
    dataIndex: 'category',
    key: 'category',
    ellipsis: true,
  },
  {
    title: '所属子标准',
    dataIndex: 'subcategory',
    key: 'subcategory',
    ellipsis: true,
  },
  {
    title: '危害因素',
    dataIndex: 'factorName',
    key: 'factorName',
    ellipsis: false,
  },
  {
    title: '检测标准',
    dataIndex: 'standardInfo',
    key: 'standardInfo',
    ellipsis: true,
  },
  {
    title: '限制范围',
    dataIndex: 'limitRange',
    key: 'limitRange',
    ellipsis: true,
  },
  {
    title: '单价(元)',
    dataIndex: 'price',
    key: 'price',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    fixed: 'right',
    width: 160,
  },
]
export default {
  components: {
    addParameter
  },
  data() {
    return {
      subCategoryData: [],
      quotePostInfo: [],
      subcategoryList: {},
      //危害因素表格数据
      harmfulData: {},
      //危害因素下拉列表
      factorList: {},
      factorList1: {},
      //危害因素详情显示与隐藏
      factorsDetailVisible: false,
      factorsTypes: '',
      //危害因素报价绑定数据
      hazardsList: [],
      // 下拉列表的行业数组
      industryNameList: [],
      allform: {},
			editId: '',
      postform1: '',
      postform: {
        creator: '',
        updateTime: '',
        updateTime: '',
        quotePostInfo: {
            industryName: '',
            postName: '',

        },
        quoteHarmFactorList1: [
          {
            price: '',
            factorName: '',
						disabled: false
          },
        ],
      },
      formfactors: {
        // 危害因素类别
        category: '',
        categoryId: 1002,
        //危害因素子类别
        subcategory: '',
        subcategoryId: '',
      },
      types: '',
      posttypes: '',
      columns,
      columnslist,
      columnslist2,
      columnslist3,
      rowform: {},
      form: {
        industryName: '',
        industryCode: '',
      },
      formHazard: {
        quotePostInfo: {
            industryId: '',
            postName: '',
        },
        quoteHarmFactorList: [
          {
            price: '',
            factorName: '',
          },
        ],
      },
      query: {
        industryName: '',
        industryCode: '',
      },
      query2: {
        postName: '',
        industryName: '',
      },
      query3: {
        industryName: '',
        categoryId: undefined,
        subcategoryId: undefined,
        factorName: '',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      pagination3: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      pagination4: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      // pagination5: {
      // 	current: 1,
      // 	pageSize: 10,
      // 	total: 0,
      // 	pageSizeOptions: ['10', '20', '30', '40', '50'],
      // 	showLessItems: true,
      // 	showSizeChanger: true,
      // },
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 20,
      },
      dataclaim2: [],
      dataclaim: [],
      datalist: [],
      addvisible: false,
      editvisiblet: false,
      addpostvisible: false,
      allvisible: false,
      postvisible: false,
      factorsvisible: false,
      scroll_y: 150,
      factorsCateList: {},
      subList: [],
      timeNow: '',
      categoryTree: [],
      rowIdNow: '',
      programName: ''
    }
  },
  created() {
   
    this.out()
    this.biz()
    this.bizList()
       // 获取项目
      getCategoryList().then(res =>{
        if(res.code == 200) {
            res.data.forEach(item => {
                if (item.id == 1) {
                    this.programName = item.categoryName
                    console.log( this.category, ' this.category===============')
                }
            })
        } else {
            this.$message.error(res.msg)
        }
        
    })
    //查询收费标准详细分类别表
    
  },
  mounted() {
    // category().then(res => {
    // 	this.cateList = res.data
    // })
     getCategoryTree().then((res) => {
      if (res.code == 200) {
        this.factorsCateList = res.data
        //子危害因素列表subCategoryData
        this.factorsCateList.forEach(item => {
          if(item.categoryId == 1000) {
            this.subCategoryData = item.childrenList
          }
        })
    
      } else {
        this.$message.error(res.msg)
      }
    })
    

    //获得行业列表数据
        this.$nextTick((res) => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 150
      }, 1000)
    })
  },
  methods: {
    closeVisible() {
       this.$refs.allForm.resetFields()
      this.allvisible = false

    },
    filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
    //删除行业信息
    confirm(row) {
        var _this = this
            var id = row.id
           this.$confirm({
					title: '是否确认删除?',
					onOk() {
           deleteIndustryInfo(row.id).then((res) => {
        if (res.code == 200) {
          _this.$message.success('删除成功')
          // this.postvisible = false
          _this.out()
        } else {
          _this.$message.error(res.msg)
        }
      })
					
					},
					onCancel() {
						_this.$message.warning('你点击了取消')
					},
					// class: 'test',
				})
    },
    changeName4(e) {
      this.subcategoryList.forEach((item) => {
        if (item.categoryId == e) {
          this.hazardsList.subcategory = item.categoryName
        }
      })
    },
  
    
    //危害因素下拉列表事件
    changeName3(e) {
      this.hazardsList.subcategory = ''
      this.subcategoryList = {}
      console.log(this.factorsCateList, 'this.factorsCateList')
      for (var i = 0; i < this.factorsCateList.length; i++) {
        if (this.factorsCateList[i].categoryId == e) {
          this.subcategoryList = this.factorsCateList[i].childrenList
        }
      }
      console.log(this.subcategoryList, 'this.subcategoryList3')
      console.log(e, 'changeName3的eeeeeeeeeeeeeeeeeee')
    },

    //编辑危害因素提交事件
    editFactorsDetail() {
      this.$refs.hazardsList.validate((valid) => {
        this.factorsCateList.forEach((item) => {
          if (item.categoryId == this.hazardsList.categoryId) {
            this.hazardsList.category = item.categoryName
          }
        })

        if (valid) {
          editFactors_put(this.hazardsList).then((res) => {
            console.log(this.hazardsList, 'this.hazardsList++++++++++++++++++++++++')
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.factorsDetailVisible = false
              this.bizList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    //危害因素详情
    details3(row) {
      // factor_details(row.id).then((res) => {
      //   this.hazardsList = res.data
      //   console.log(res.data, 'res.data++++++++++++++++++++++++')
      //   console.log(this.hazardsList, 'this.hazardsList++++++++++++++++++++++++')
      // })
       this.hazardsList  = []
       this.hazardsList  = JSON.parse(JSON.stringify(row))
       console.log( this.hazardsList, ' this.hazardsList this.hazardsList this.hazardsList this.hazardsList this.hazardsList')
      this.factorsDetailVisible = true
      this.factorsTypes = 0
    },
    // 删除危害因素
    delete3(row) {
        var _this = this
            var id = row.id
           this.$confirm({
					title: '是否确认删除?',
					onOk() {

      delete_factor(row.id).then((res) => {
        if (res.code == 200) {
          _this.$message.success('删除成功')
          // this.postvisible = false
          _this.bizList()
        } else {
          _this.$message.success(res.msg)
        }
      })
					
					},
					onCancel() {
						_this.$message.warning('你点击了取消')
					},
					// class: 'test',
				})









      // this.factorsDetailVisible = true
      // this.factorsTypes = 0
    },
    //编辑危害因素显示与隐藏
    edit3(row) {
      this.hazardsList = []

      // //获取对应行的危害因素详细信息
      this.hazardsList  = JSON.parse(JSON.stringify(row))
      // factor_details(row.id).then((res) => {
      //   this.hazardsList = res.data
      //   console.log(res.data, 'res.data++++++++++++++++++++++++')
      //   console.log(this.hazardsList, 'this.hazardsList++++++++++++++++++++++++')
      //   // })
      // })
      this.factorsDetailVisible = true
      this.factorsTypes = 1
    },
    //关闭危害因素弹窗
    closeHazards() {
      this.$nextTick(() => {
        this.$refs.hazardsList.resetFields()
        this.factorsDetailVisible = false
        //    this.factorsTypes = 1
      })
    },

    //关闭新增行业弹窗
    resetAddIndustry() {
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
        this.addvisible = false
      })
    },
    changeSub(event) {
      console.log(event, 'event==========================')
      this.$forceUpdate()
      // subCategory({
      // 	parentId: event
      // }).then(res => {
      // 	this.subList = res.data
      // 	this.hazardsList.subcategory = ''
      // })
    },

    factorsAdd() {
      this.factorsvisible = true
    },
    getOkPost() {

				console.log(this.postform, 'this.postform===========================')
      this.$refs.postForm.validate((valid) => {
        if (valid) {
					
					Object.assign(this.postform.quotePostInfo,{id:this.editId})
          
          // var bizAnticipateGoods = []
          // _this.harmfulData.forEach((item) => {
          //   bizAnticipateGoods.push({
          //     factorName: item.factorName,
          //     price: item.price,
          //   })
          // })
				
          editPostWithHarmFactor({
            quotePostInfo: this.postform.quotePostInfo,
            quoteHarmFactorList: this.postform.quoteHarmFactorList1
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.postvisible = false
              this.biz()
            } else {
              this.$message.success(res.msg)
            }
          })
        }
      })
			this.postedit()
    },
    getOkAll() {
      this.$refs.allForm.validate((valid) => {
        if (valid) {
          Object.assign(this.allform, {
            projectId: 1
          })
          industryInfo_put(this.allform).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.allvisible = false
              this.out()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    details(row) {
      industryInfo_details(row.id).then((res) => {
        if(res.code==200) {
           this.allform = res.data
        // this.getTimeNow()
        // this.allform.updateTime = this.timeNow
        console.log(this.allform, 'this.allform++++++++++++++++++++++++')

        }
       
      })
      this.allvisible = true
      this.types = 0
    },
    edit(row) {
      industryInfo_details(row.id).then((res) => {
        this.allform = res.data
      })
      this.allvisible = true
      this.types = 1
    },
    getTimeNow() {
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      //以下代码依次是获取当前时间的年⽉⽇时分秒
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var minute = date.getMinutes()
      var hour = date.getHours()
      var second = date.getSeconds()
      //固定时间格式
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
      }
      if (minute >= 0 && minute <= 9) {
        minute = '0' + minute
      }
      if (second >= 0 && second <= 9) {
        second = '0' + second
      }

      this.timeNow =
        year + seperator1 + month + seperator1 + strDate + ' ' + hour + seperator2 + minute + seperator2 + second
    },
   getRowDetail() {
      getUserListDetail({
        pageSize: this.pagination4.pageSize,
        pageNum: this.pagination4.current,
        postId:  this.rowIdNow,
        // categoryId: this.query4.categoryId,
        // subcategoryId: this.query4.subcategoryId,
        // factorName: this.query4.factorName,
      }).then((res) => {
        this.harmfulData = res.data
        console.log(this.harmfulData, 'this.harmfulData +++++++++++++++')
        const pagination = {
          ...this.pagination4,
        }
        pagination.total = res.total
        this.pagination4 = pagination
      })
   },
    postdetails(row) {
      this.rowIdNow = row.id
      this.getRowDetail()
      postInfo_details(row.id).then((res) => {
        console.log( res.data, ' res.data3333333333333333333333333========================')
        this.postform1 = res.data
        // this.getTimeNow()
        // console.log(this.postform.updateTime, 'this.postform.updateTime+++++++++++++++++++')
        // this.postform1.updateTime = this.timeNow
      })
      this.postvisible = true
      this.posttypes = 0
    },
    getFactorList() {
      getUserList().then((res) => {
        this.factorList = res.data
        console.log(this.factorList, 'this.factorList1+++++++++++++++++++++++')
      })
    },
    postedit(row) {
			this.editId = row.id
      //编辑岗位信息
      
      postInfo_details(row.id).then((res) => {
        console.log(res, 'res333333===================================')
        this.postform.quotePostInfo.industryName = ''
        this.postform.quotePostInfo.postName = ''
        this.postform.quotePostInfo.industryName = res.data.industryName
        this.postform.quotePostInfo.postName = res.data.postName

				// Object.assign(this.postform.quotePostInfo,{industryName:res.data.industryName})
				// 	Object.assign(this.postform.quotePostInfo,{postName:res.data.postName})
        // this.postform = res.data
        // this.getTimeNow()
        // this.postform.updateTime = this.timeNow
        
      })
				 getUserListDetail({ postId: this.editId }).then((res) => {
				  const quoteHarmFactorList1 = res.data.map(item => {
						 return {
							 factorName: item.factorName,
               fullName: item.fullName,
               baseId: item.baseId,
							 price: item.price,
							 disabled: true
						 }
					 })

        // this.postform.quoteHarmFactorList1 = res.data
				Object.assign(this.postform,{quoteHarmFactorList1})
					// console.log(this.postform.quoteHarmFactorList1, 'this.postform.quoteHarmFactorList1========================')
					console.log(this.postform, 'this.postform++++++++++++++++++++++++')
      })
      
			
			this.getFactorList()
      this.postvisible = true
      this.posttypes = 1
    },
    close_detail(index) {
      console.log(index, 'index====================')
      this.formHazard.quoteHarmFactorList.splice(index, 1)
    },
    close_detail1(index) {
      this.postform.quoteHarmFactorList1.splice(index, 1)

    },
    addPush() {
      this.formHazard.quoteHarmFactorList.push({
        price: '',
        factorName: '',
      })
      this.$forceUpdate()
    },
    addPush1() {
      this.postform.quoteHarmFactorList1.push({
        price: '',
        factorName: '',
				disabled: false
      })
      this.$forceUpdate()
    },
		changeHarmFactor(e, index) {
      this.formHazard.quoteHarmFactorList.factorName = ''
      this.formHazard.quoteHarmFactorList.price = ''
       this.factorList.forEach(item => {
         if(item.id == e) {
           this.formHazard.quoteHarmFactorList[index].factorName = item.factorName
            Object.assign( this.formHazard.quoteHarmFactorList[index], {
            baseId:   this.formHazard.quoteHarmFactorList[index].fullName,
            standardInfo: item.standardInfo
          }) 
	        	this.formHazard.quoteHarmFactorList[index].price =item.price
            console.log( this.formHazard.quoteHarmFactorList[index], 	this.formHazard.quoteHarmFactorList[index].price, '===================================')
         }
       })
			this.$forceUpdate()
		
   
		},
		changeName1(e, index) {
         this.postform.quoteHarmFactorList1.factorName = ''
		this.postform.quoteHarmFactorList1.price = ''
			console.log(e, index, '===================================')
			
       this.factorList.forEach(item => {
         if(item.id == e) {
           this.postform.quoteHarmFactorList1[index].factorName = item.factorName
          Object.assign(this.postform.quoteHarmFactorList1[index], {
            baseId:  this.postform.quoteHarmFactorList1[index].fullName,
            standardInfo: item.standardInfo
          }) 
		       this.postform.quoteHarmFactorList1[index].price = item.price
            console.log( this.postform.quoteHarmFactorList1[index].factorName, this.postform.quoteHarmFactorList1[index].price, '===================================')
         }
       })
       this.$forceUpdate()
		
		},
    changeName(value) {
      this.$forceUpdate()
      this.datalist.forEach((item) => {
        if (item.id == value) {
          this.formHazard.quotePostInfo.industryName = item.value
          this.postform.quotePostInfo.industryName = item.value
          this.formHazard.quotePostInfo.industryName = item.industryName
          this.allform.industryName = item.industryName
          this.hazardsList.category = item.industryName
          this.postform.quotePostInfo.industryName = item.industryName
        }
      })
    },
    addOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          industryInfo_post({
            ownProject: '职业病危害因素检测与评价',
            projectId: 1,
            industryCode: this.form.industryCode,
            industryName: this.form.industryName,
          }).then((res) => {
            if (res.code == 200) {
              this.$refs.ruleForm.resetFields()
              this.$message.success('新增成功')
              this.addvisible = false
              this.out()
            } else {
              this.$message.success(res.msg)
            }
          })
        }
      })
    },

    //关闭新增岗位弹窗
    closeAddPost() {
      this.$nextTick(() => {
        this.$refs.ruleForm2.resetFields()
      })
      this.addpostvisible = false
    },
    addpostOk() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
 
            // this.quotePostInfo.industry = this.formHazard.industry,
            // this.quotePostInfo.postName = this.formHazard.postName,
            // this.quotePostInfo.industryId = this.formHazard.industryId,
          // var lis = {
            // quotePostInfo: this.quotePostInfo,
            // quoteHarmFactorList: this.formHazard.quoteHarmFactorList
						// industry: this.formHazard.industry,
            // postName: this.formHazard.postName,
            // industryId: this.formHazard.industryId,
            // industryName: this.formHazard.industryName,
          // }
					// console.log(this.formHazard.industry, 'this.formHazard.industry')
          addPostWithHarmFactor({
            quotePostInfo: this.formHazard.quotePostInfo,
            quoteHarmFactorList: this.formHazard.quoteHarmFactorList
            // quotePostInfo: lis,
            // quoteHarmFactorList: this.formHazard.quoteHarmFactorList,
          }).then((res) => {
            if (res.code == 200) {
              this.formHazard.quotePostInfo.industryName = ''
              this.formHazard.quotePostInfo.industryId = ''
			        this.formHazard.quotePostInfo.postName = ''
			        this.formHazard.quotePostInfo.baseId = ''
			        this.formHazard.quoteHarmFactorList.splice(2, this.formHazard.quoteHarmFactorList.length-1)
              this.formHazard.quoteHarmFactorList[0].fullName = undefined
			        this.formHazard.quoteHarmFactorList[0].baseId = undefined
			        this.formHazard.quoteHarmFactorList[0].price= ''
              this.$refs.ruleForm2.resetFields()
              // this.this.formHazard.quotePostInfo.industryName = ''
              this.$message.success('新增成功')
              this.addpostvisible = false
              this.biz()
            } else {
              this.$message.success(res.msg)
            }
          })
        }
      })
    },
    closeFactor() {
      this.$nextTick(() => {
        this.$refs.ruleForm3.resetFields()
      })
      this.factorsvisible = false
    },

    factorsOk() {
      this.$refs.ruleForm3.validate((valid) => {
        if (valid) {
          this.factorsCateList.forEach((item) => {
            if (item.categoryId == this.formfactors.categoryId) {
              this.formfactors.category = item.categoryName
            }
          })
          this.subcategoryList.forEach((item) => {
            if (item.categoryId == this.formfactors.subcategoryId) {
              this.formfactors.subcategory = item.categoryName
            }
          })
          console.log(this.formfactors, 'this.formfactors++++++++++++++++++++++++++++++')
          baseFactor_add(this.formfactors).then((res) => {
            if (res.code == 200) {
              this.$refs.ruleForm3.resetFields()
              this.$message.success('新增成功')
              this.factorsvisible = false
              this.bizList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    modification() {
      this.addvisible = true
    },
    PostWith() {
      this.addpostvisible = true
      //获得危害因素下拉列表
      getUserList().then((res) => {
        this.factorList = res.data
        console.log(this.factorList, 'this.factorList+++++++++++++++++++++++')
      })
      this.formHazard = {
        quotePostInfo: {
					
          industryId: '',
          industryName: '',
          postName: '',
        },
        quoteHarmFactorList: [
          {
            price: '',
            factorName: undefined,
          },
        ],
      }
    },
    //修改时获取危害因素列表
    //   harmfulList2(){
    //获取危害因素列表
    // ().then(res => {
    // 	console.log(this.res,'res+++++++++++++++++++')

    // })
    // 	getFactorDetail({
    // 		pageSize: this.pagination5.pageSize,
    // 		pageNum: this.pagination5.current,
    // 		// categoryId: this.query4.categoryId,
    // 		// subcategoryId: this.query4.subcategoryId,
    // 		// factorName: this.query4.factorName,
    // 	}).then((res) => {
    // 		this.harmfulData = res.data
    // 		console.log(this.harmfulData ,'this.harmfulData +++++++++++++++')
    // 		const pagination = {
    // 			...this.pagination5
    // 		}
    // 		pagination.total = res.total
    // 		this.pagination5 = pagination
    // 	})
    // },
    //获取危害因素列表
    harmfulList() {
      //获取危害因素列表
      // ().then(res => {
      // 	console.log(this.res,'res+++++++++++++++++++')
      // })
    },
    biz() {
      postInfo({
        pageSize: this.pagination2.pageSize,
        pageNum: this.pagination2.current,
        postName: this.query2.postName,
        industryName: this.query2.industryName,
      }).then((res) => {
        this.dataclaim = res.data
        console.log(this.dataclaim, 'this.dataclaim33333333333333333333333333333333333333333333')
        const pagination = {
          ...this.pagination2,
        }
        pagination.total = res.total
        this.pagination2 = pagination
      })
    },

    bizList() {
      baseFactor({
        pageSize: this.pagination3.pageSize,
        pageNum: this.pagination3.current,
        // categoryId: 1002,
         categoryId: this.query3.categoryId,
        subcategoryId: this.query3.subcategoryId,
        factorName: this.query3.factorName,
      }).then((res) => {
        this.dataclaim2 = res.data
        const pagination = {
          ...this.pagination3,
        }
        pagination.total = res.total
        this.pagination3 = pagination
      })
    },
    biz() {
      postInfo({
        pageSize: this.pagination2.pageSize,
        pageNum: this.pagination2.current,
        postName: this.query2.postName,
        industryName: this.query2.industryName,
      }).then((res) => {
        this.dataclaim = res.data
        const pagination = {
          ...this.pagination2,
        }
        pagination.total = res.total
        this.pagination2 = pagination
      })
    },
    out() {
      industryInfo({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        industryName: this.query.industryName,
        industryCode: this.query.industryCode,
        projectId: 1
      }).then((res) => {
        this.datalist = res.data
        console.log(this.datalist, 'this.datalist=========================================')

        // var newDataList = [res.data[0]]
        // for(var i = 0; i <= res.data.length; i++){
        // 	if(newDataList.indexOf(res.data[i] == 1)) {
        // 		newDataList.push(res.data[i])

        // }
        // }
        const pagination = {
          ...this.pagination,
        }
        pagination.total = res.total
        this.pagination = pagination
      })
    },
    callback(key) {
      this.out()
      this.biz()
      this.bizList()
      this.pagination.current = 1
      this.pagination2.current = 1
      this.pagination3.current = 1
    },
    queryall() {
      this.query = {}
    },
    queryall2() {
      this.query2 = {}
    },
    queryall3() {
      this.query3 = {}
    },
    changeTable(pagination) {
      this.pagination.current = pagination.current
      console.log(this.pagination.current, 'this.pagination.current+++++++++++++++++++++')
      this.pagination.pageSize = pagination.pageSize
      console.log(this.pagination.pageSize, 'this.pagination.pageSize++++++++++++++++++++')
      this.out()
    },
    changeTableclaim(pagination) {
      this.pagination2.current = pagination.current
      this.pagination2.pageSize = pagination.pageSize
      this.biz()
    },
    changeTableclaim2(pagination) {
      this.pagination3.current = pagination.current
      this.pagination3.pageSize = pagination.pageSize
      this.bizList()
    },
    changeTableclaim4(pagination) {
    	this.pagination4.current = pagination.current
    	this.pagination4.pageSize = pagination.pageSize
    	this.getRowDetail()

    },
    // changeTableclaim5(pagination) {
    // 	this.pagination5.current = pagination.current
    // 	this.pagination5.pageSize = pagination.pageSize
    // 	this.harmfulList2()

    // },
    queryserch() {
      this.pagination.current = 1
      this.out()
    },
    queryserch2() {
      this.pagination2.current = 1
      this.biz()
    },
    queryserch3() {
      this.pagination3.current = 1
      this.bizList()
    },
  },
}
</script>

<style>
.content_main {
  padding: 10px;

}
.rowBox {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close_icon {
  font-size: 10px;
  color: red;
  cursor: pointer;
  margin-bottom: 10px;
}

.form_title {
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}
.ant-modal-body {
  background-color: #f8f8f8;
}

.baseContainer {
  border-radius: 15px;
  margin: 10px 0;
  background-color: #fff;
}
.sizeStyle {
  font-size: 18px;
  font-weight: 700;
}
.tmp{
  white-space:nowrap;/*强制单行显示*/
  text-overflow:ellipsis;/*超出部分省略号表示*/
  overflow:hidden;/*超出部分隐藏*/
  width: 100%; /* 设置显示的最大宽度 */
  display:inline-block;
}
.tmp-next{
  vertical-align: top;
}

</style>
